import React from 'react';
import { AutodeskBrandingStyled } from './LoginWrapper.styles';
export default function AutodeskBranding() {
    return React.createElement(AutodeskBrandingStyled, null);
}
